import HeaderModal from "../HeaderModal/HeaderModal";
import { Link } from 'react-router-dom';
import { useState } from "react";
import axios from "axios";
import {
  Overlay,
  FormContainer,
  Title,
  Form,
  InputGroup,
  Input,
  SubmitButton,
  LoginLink,
  InputEmail
} from "./SignUp.style";

const SignUp = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    medicalAdvisor: "",
    specialty: "",
    email: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email || !formData.firstName || !formData.lastName) {
      alert("Por favor complete los campos requeridos");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/signup`, formData);
      
      if (response.data.success) {
        // Clear the form
        setFormData({
          firstName: "",
          lastName: "",
          medicalAdvisor: "",
          specialty: "",
          email: ""
        });
        alert(response.data.message);
      } else {
        alert("Hubo un error al enviar el formulario. Por favor intente nuevamente.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Hubo un error al procesar el formulario. Por favor intente nuevamente.");
    }
    setIsSubmitting(false);
  };

  return (
    <Overlay>
      <HeaderModal />
      <FormContainer>
      <LoginLink>
          Miembros Eupha
        </LoginLink>
        <Title>Hazte miembro</Title>
        <LoginLink>
          ¿Ya eres un miembro? <Link to='/login'>Iniciar Sesión</Link>
        </LoginLink>
        <Form onSubmit={handleSubmit}>
          <InputGroup>
            <Input 
              type="text" 
              name="firstName"
              required 
              placeholder="Nombre:"
              value={formData.firstName}
              onChange={handleChange}
            />
            <Input 
              type="text" 
              name="lastName"
              required 
              placeholder="Apellido:"
              value={formData.lastName}
              onChange={handleChange}
            />
          </InputGroup>
          <InputGroup>
            <Input 
              type="text" 
              name="medicalAdvisor"
              required 
              placeholder="Asesor Médico:"
              value={formData.medicalAdvisor}
              onChange={handleChange}
            />
            <Input 
              type="text" 
              name="specialty"
              required 
              placeholder="Especialidad:"
              value={formData.specialty}
              onChange={handleChange}
            />
          </InputGroup>
          <InputGroup>
            <InputEmail 
              type="email" 
              name="email"
              required 
              placeholder="Correo:"
              value={formData.email}
              onChange={handleChange}
            />
          </InputGroup>
          <SubmitButton>
            <button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Enviando..." : "Enviar formulario"}
            </button>
          </SubmitButton>
        </Form>

      </FormContainer>
    </Overlay>
  );
}

export default SignUp;
